import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('umb-market-error')
export class UmbMarketError extends LitElement {
  render() {debugger;
    return html` <h2>Page not found</h2> `;
  }

  static styles = css`
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 100px;
    }

    h2 {
      color: var(--uui-color-default);
    }
  `;
}
